import { SET_PANEL_DELIVERY_REPORTS } from '../actions/types';

const createEmptyModeState = () => ({
    summary: [],
    totalRecords: 0,
    nextPage: false,
    page: 1,
    pageSize: 250,
    appliedStartDate: '',
    appliedEndDate: '',
    appliedProjectNo: '',
    appliedCustomerName: '',
    isLoaded: false,
});

const initialState = {
    partial: createEmptyModeState(),
    full: createEmptyModeState(),
    both: createEmptyModeState(),
};

export default function panelDeliveryReportsReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PANEL_DELIVERY_REPORTS:
            return {
                ...state,
                [payload.mode]: {
                    ...state[payload.mode],
                    ...payload.data,
                    isLoaded: true,
                },
            };
        default:
            return state;
    }
}
